import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flow__content" }
const _hoisted_2 = { class: "editable-header spacing-bottom-1-xs spacing-bottom-2-sm" }
const _hoisted_3 = { class: "m-content-section__subtitle" }
const _hoisted_4 = {
  class: "spacing-top-3-xs spacing-bottom-3-xs",
  style: {"max-width":"320px"}
}
const _hoisted_5 = { class: "a-input-costcalc" }
const _hoisted_6 = { class: "a-input-costcalc__info" }
const _hoisted_7 = { class: "a-input-costcalc__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("kilometers-question")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("kilometers-text")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("kilometers-unit")), 1),
        _withDirectives(_createElementVNode("input", {
          class: "a-input-costcalc__number",
          type: "number",
          min: "1",
          step: "1",
          placeholder: " ",
          onkeypress: "return event.charCode >= 48 && event.charCode <= 57",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentKilometers) = $event))
        }, null, 512), [
          [_vModelText, _ctx.currentKilometers]
        ]),
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("kilometers-per-year-label")), 1)
      ])
    ])
  ]))
}